import { formatDate } from '@common/paymentsUtils/dateUtils';
import UserEventTypes from '../constants/UserEventConstants';
import { IUserEventModel } from './Types';

export default (userEvents: IUserEventModel[]): Record<string, any> => {
  if (!userEvents || userEvents.length < 1) {
    return {};
  }

  const UserEventsArray = Object.keys(UserEventTypes);
  for (let i = 0; i < UserEventsArray.length; i++) {
    const currentEvents = userEvents.filter((event) => event.eventType === UserEventsArray[i]);

    if (currentEvents.length > 0) {
      const latestEvent = currentEvents[0];

      // We chose to remove the "paymentScheduled" state from the UI (PAY-1444)
      if (latestEvent.eventType === 'paymentScheduled') {
        return {};
      }

      const dateString = formatDate(latestEvent.createdDate, 'M/d/yy');
      return {
        type: UserEventTypes[UserEventsArray[i]],
        date: dateString,
        message: `${UserEventTypes[UserEventsArray[i]]} ${dateString}`,
      };
    }
  }

  return {};
};
